import { AutoplayDetection } from './autoplay-detection';
import { CanAutoPlayResult, CanAutoplay } from './can-autoplay';

/**
 * By default a separate video element is created for the autoplay check.
 * This helps to decrease the chance of side effects and works well for more lenient browsers.
 */
export class DefaultAutoplayDetection extends AutoplayDetection {
  private readonly canAutoplay: CanAutoplay;

  constructor() {
    super();
    this.canAutoplay = new CanAutoplay();
  }

  protected isAutoplaySupportedForPlatform(_: HTMLVideoElement, isMuted: boolean): Promise<CanAutoPlayResult> {
    const videoElement = document.createElement('video');
    videoElement.muted = isMuted;
    videoElement.autoplay = true;
    videoElement.playsInline = true;

    return this.canAutoplay.video(videoElement).finally(() => {
      videoElement.remove();
    });
  }
}
